import { get } from 'lodash';
import React from 'react';
import { useHistory, useParams } from 'react-router';
import _TopRight from 'src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';

import MultiLangDropDown from '@/src/constrains/SalesChannelMultiLanguageSelect/MultiLangDropDown';
import { EnumMultiLanguageType } from 'src/constrains/SalesChannelMultiLanguageSelect';

const TopRight = (props) => {
  const { hasModified, onSubmit, disableEdit, isNew } = props;
  // const actionGenerator = () => {
  //   const overlay = (
  //     <Menu className={css.menu}>
  //       <MenuItem className={css.menuItem} onClick={onDuplicate}>
  //         Duplicate
  //       </MenuItem>
  //       <MenuItem className={css.menuItemArchive} onClick={onArchive}>
  //         Archive
  //       </MenuItem>
  //     </Menu>
  //   );

  //   if (status !== EnumStatus.Archived) {
  //     return (
  //       <div className={css.actionBtnContainer}>
  //         <DropDown.Button
  //           className={css.actionBtn}
  //           overlay={overlay}
  //           placement='bottomRight'
  //           trigger={['click']}>
  //           Actions
  //         </DropDown.Button>
  //       </div>
  //     );
  //   }
  // };

  // const greenBtn = () => {
  //   if (status === EnumStatus.Draft) {
  //     return (
  //       <Button
  //         type='primary'
  //         className={css.greenBtn}
  //         onClick={onPublish}
  //         ghost>
  //         Publish
  //       </Button>
  //     );
  //   }
  //   if (
  //     status === EnumStatus.Active ||
  //     status === EnumStatus.Scheduled ||
  //     status === EnumStatus.Expired
  //   ) {
  //     return (
  //       <Button type='primary' className={css.greenBtn} onClick={onDraft} ghost>
  //         Switch To Draft
  //       </Button>
  //     );
  //   }
  //   if (status === EnumStatus.Archived) {
  //     return (
  //       <Button
  //         className={css.greenBtn}
  //         type='primary'
  //         onClick={onRestore}
  //         ghost>
  //         Restore
  //       </Button>
  //     );
  //   }
  // };
  // const rightBtnGenerator = () => {
  //   if (isNew) {
  //     return null;
  //   }
  //   return (
  //     <React.Fragment>
  //       {/* {actionGenerator()} */}
  //       {/* {greenBtn()} */}
  //     </React.Fragment>
  //   );
  // };

  const s = useParams();
  const salesChannelUuid = get(s, 'uuid');

  const h = useHistory();
  const onD = () => {
    h.push(`/salesChannel/discounts/voucher/list/${salesChannelUuid}`);
  };
  return (
    <_TopRight
      onDiscard={onD}
      onSaveDisable={!hasModified || disableEdit}
      onSubmit={onSubmit}
      //  extendButton={isPrimary ? rightBtnGenerator() : null}
      extraLeft={
        isNew ? null : (
          <div style={{ marginRight: 8 }}>
            <MultiLangDropDown
              customType={
                EnumMultiLanguageType.SalesChannelDiscountsGiftPurchase
              }
              hasModified={hasModified}
              salesChannelUuidKey='uuid'
            />
          </div>
        )
      }
    />
  );
};
export default TopRight;
